import React from 'react';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Card, CardContent } from '@tmap/mmm-style-guide/src/Card';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Add } from '@tmap/mmm-style-guide/src/Icon';

const CTACard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '8px',
  width: '100%',
  textAlign: 'center',
}));

function FullWidthPostCTA({ onPostClick }) {
  return (
    <CTACard elevation={0}>
      <CardContent sx={{ height: '100%', padding: '30px' }}>
        <Typography variant='h6' color='primary' sx={{ mb: 0.5 }}>No posts to show</Typography>
        <Typography variant='body1'>There’s no activity at the moment, but we can totally solve that.</Typography>
        {onPostClick && (
          <Box sx={{ mt: 3 }}>
            <Button
              variant='contained'
              color='inverted'
              onClick={onPostClick}
            >
              <Add /> Submit a Post
            </Button>
          </Box>
        )}
      </CardContent>
    </CTACard>
  );
}

export default FullWidthPostCTA;
